export default "__VITE_ASSET__4j4wVWij__"